var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispensarioSinComunicacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 53,
    viewBox: "0 0 40 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 42.5V4L8.5 1H31.5L34.5 4V44L38.5 46.5V51H2V45L5 42.5ZM11.5 10V22.5H28V10H11.5Z",
    fill: "#FF7171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4375 6.60078C36.4375 2.94781 33.5445 0 29.8916 0H10.0166C6.36362 0 3.3125 2.94781 3.3125 6.60078V43.6707L0.915493 44.8692C0.354229 45.1498 0 45.7232 0 46.3508V51.3195C0 52.2342 0.820671 53 1.73534 53H38.1728C39.0875 53 39.75 52.2342 39.75 51.3195V46.3508C39.75 45.7232 39.3958 45.1498 38.8345 44.8692L36.4375 43.6707V6.60078ZM3.3125 49.6875H36.4375V47.3745L34.0405 46.1761C33.4792 45.8955 33.125 45.3221 33.125 44.6945V6.60078C33.125 4.77383 31.7184 3.3125 29.8916 3.3125H10.0166C8.18964 3.3125 6.625 4.77383 6.625 6.60067V44.6944C6.625 45.322 6.27077 45.8954 5.70951 46.176L3.3125 47.3745V49.6875Z",
    fill: "#DB121F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 9.9375C29.8125 9.02273 29.071 8.28125 28.1562 8.28125H11.5938C10.679 8.28125 9.9375 9.02273 9.9375 9.9375V23.1875C9.9375 24.1023 10.679 24.8438 11.5938 24.8438H28.1562C29.071 24.8438 29.8125 24.1023 29.8125 23.1875V9.9375ZM26.5 21.5312H13.25V11.5938H26.5V21.5312Z",
    fill: "#DB121F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispensarioSinComunicacion);
export default __webpack_public_path__ + "static/media/dispensario_sin_comunicacion.ca03a26f8f9d78212b33aeb7ac85582b.svg";
export { ForwardRef as ReactComponent };